/* @flow */

import React from 'react';
// import cx from 'classnames';
import { Button, ButtonGroup } from 'reactstrap';
import FaFile from 'react-icons/lib/fa/file';
import FaPencil from 'react-icons/lib/fa/pencil';
import FaCloud from 'react-icons/lib/fa/cloud';
import FaCopy from 'react-icons/lib/fa/copy';
import FaFolderOpen from 'react-icons/lib/fa/folder-open';
import FaFileText from 'react-icons/lib/fa/file-text';

import { branch } from '../../utils';
// import classes from './LeftToolBar.scss';

type PropsType = {
  designName: string,
  disableOpen: boolean,
  disableRedo: boolean,
  disableSave: boolean,
  disableUpdate: boolean,
  id: number,
  isSavedDesign: boolean,
  onDuplicateDesign(id: number): void,
  onNewDesign(): void,
  onOpen(): void,
  onRedo(): void,
  onSave(): void,
  onUpdateDesign(): void,
};

export class LeftToolBar extends React.PureComponent<PropsType, *> {
  static defaultProps = {};

  props: PropsType; // eslint-disable-line react/sort-comp

  render() {
    const props = this.props;

    return (
      <ul className="nav">
        <li className="nav-item">
          <Button size="sm" title="New Design" onClick={props.onNewDesign}>
            <FaFile /> New
          </Button>
        </li>
        <li className="nav-item">
          <Button
            title="Manage Your Designs"
            size="sm"
            onClick={props.onOpen}
            disabled={props.disableOpen}
          >
            <FaFolderOpen /> My Designs
          </Button>
        </li>
        <li className="nav-item">
          {branch(
            props.isSavedDesign,
            <ButtonGroup>
              <Button
                size="sm"
                title="Save Design Changes"
                onClick={props.onUpdateDesign}
                disabled={props.disableUpdate}
                style={{ marginRight: 0 }}
              >
                <FaPencil /> Save
              </Button>
              <Button
                size="sm"
                title="Duplicate Current Design"
                onClick={() => props.onDuplicateDesign(props.id)}
                disabled={props.disableSave}
              >
                <FaCopy />
              </Button>
            </ButtonGroup>,
            <Button
              size="sm"
              title="Save Current Design"
              onClick={props.onSave}
              disabled={props.disableSave}
            >
              <FaCloud /> Save As
            </Button>,
          )}
        </li>
        <li className="nav-item align-self-center d-inline-flex">
          <FaFileText style={{ margin: '0 0.25rem 0.25rem 1rem' }} />
          {this.props.designName || process.env.REACT_APP_INITIAL_DESIGN_NAME}
        </li>
      </ul>
    );
  }
}

export default LeftToolBar;



// WEBPACK FOOTER //
// ./src/components/LeftToolBar/LeftToolBar.js